/**
 * Hidden "parent" stations of a multi-visit aid station (AD-644)
 * ==============================================================
 *
 * A station the course passes more than once — Deception Pass's Cornet,
 * visited 3 times — is stored as ONE bookkeeping parent row ("Cornet",
 * expected_visits = 3, no parent of its own) plus one real row per visit
 * ("Cornet 1", "Cornet 2", "Cornet 3", each pointing at the parent). The
 * parent is never a place a runner checks in at; it only exists so the
 * visits can share a count.
 *
 * So it must never be SHOWN: not on the elevation profile, not in the
 * runner list, and not in a runner's Timing Points table. It was showing in
 * Timing Points (as "Cornet · 21.4 mi", sorted right after Bowman), which also
 * pushed the NEXT badge onto it instead of the runner's real next stop.
 *
 * Same rule as the web app's isHiddenParentRow (web/lib/events/hidden-parent.ts):
 * more than one expected visit and no parent. The status calculation still
 * receives the FULL list (lib/runnerStatus.ts uses expected_visits itself) —
 * only what's displayed is filtered.
 */
export function isHiddenParentStation(s: {
  expected_visits?: number | null;
  parent_station_id?: string | number | null;
}): boolean {
  return (s.expected_visits ?? 1) > 1 && (s.parent_station_id == null || s.parent_station_id === '');
}
